import styled from "styled-components";
import { DatePicker as ANTDDatePicker} from "antd";

export const AccountDatePicker = styled(ANTDDatePicker)`
    width: 100%;
    font-size: 14px;
    padding: unset;

    .ant-picker-input > input {
        border-radius: unset;
    }

    .ant-picker-input > input:focus {
        border-bottom: 1px solid #6b7384;
    }

    .anticon-close-circle {
        color: red;
        background-color: #e9ecf2;
    }

`;

export const Body = styled.div`
    
`;

export const Main = styled.div`
    padding: 6px 8px 6px 11px;
    border-radius: 8px;
    background-color: #e9ecf2;
    width: 100%;

    label{
        font-size: 11px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.18;
        letter-spacing: normal;
        text-align: left;
        color: #6b7384;
        margin-bottom: 0px;
        display: block;
    }
`;